import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "menu"]

  toggle(event) {
    event.stopPropagation()
    if (this.menuTarget.hasAttribute("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.removeAttribute("hidden")
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.menuTarget.setAttribute("hidden", "")
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  closeOnOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }
}
